/*@ngInject*/
const MarkAsLostMediator = function (markSubmissionLostRepository) {

    this.createMarkAsLostForm = function (submissionId) {
        return markSubmissionLostRepository.createMarkAsLostForm(submissionId);
    };

    this.deleteMarkAsLostForm = function (submissionId) {
        return markSubmissionLostRepository.deleteMarkAsLostForm(submissionId);
    }
};

angular.module('gw-um-submission')
    .service('markAsLostMediator', MarkAsLostMediator);
